import { ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../_services/auth.service";
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  private windowsAgent = false;
  private computerIdentifier: string | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      const comp = params['computer'] ?? localStorage.getItem('computer');
      if (comp) {
        this.windowsAgent = true;
        this.computerIdentifier = String(comp);
        localStorage.setItem('computer', this.computerIdentifier); // persiste
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const user = this.authenticationService.userValue as any | null;
    const isLoggedIn = !!user?.token;
    const isApiUrl = this.isApiCall(request.url);

    // Build headers incrementais
    const setHeaders: Record<string, string> = {};

    if (isLoggedIn && isApiUrl) {
      setHeaders['Authorization'] = `Bearer ${user!.token}`;
    }

    // Mantém o cabeçalho do “agente” se existir
    if (this.windowsAgent && this.computerIdentifier) {
      // Mantive "Authorize" porque é o que já usas no servidor;
      // se for suposto ser "X-Computer" ou "X-Agent", renomeia nos dois lados.
      setHeaders['Authorize'] = this.computerIdentifier;
    }

    if (Object.keys(setHeaders).length) {
      request = request.clone({ setHeaders });
    }

    return next.handle(request);
  }

  private isApiCall(url: string): boolean {
    // cobre chamadas absolutas e relativas
    try {
      const u = new URL(url, window.location.origin);
      return u.href.startsWith(environment.baseUrl);
    } catch {
      return url.startsWith(environment.baseUrl) || url.startsWith('/api/');
    }
  }
}